'use client';

import SidebarLayout, { LoadingProvider } from '@/src/components/SidebarLayout';
import type { ReactNode } from 'react';

export default function SidebarContentLayout({
  children
}: {
  children: ReactNode;
}) {
  return (
    <LoadingProvider>
      <SidebarLayout>{children}</SidebarLayout>
    </LoadingProvider>
  );
}
